/**
 *  @fileOverview Dropdown module, initalises dropdown elements code repurposed from https://dev.to/emmawedekind/creating-a-custom-accessible-drop-down-3gmo
 *
 *  @author       Chris Hill
 *
 */

function DropdownModule () {
  /**
   * @description Initialises dropdown instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Get all dropdowns
     */
    var dropdowns = document.querySelectorAll('button[data-toggle="dropdown"]')

    /**
     * Only run if dropdown elements exist
     */
    if (dropdowns.length > 0) {
      /**
       * Loop through and add click events
       */
      dropdowns.forEach((drop, index) => {
        /**
         * Key codes
         */
        const ENTER_KEY_CODE = 13
        const ESCAPE_KEY_CODE = 27

        const list = drop.parentElement.querySelector('.dropdownMenu')
        const listItems = list.querySelectorAll('li')
        const listItemIds = []
        const persona = drop.classList.contains('personaSelection__select')

        /**
         * Check if the select belongs to a personaSelection. If it does check for URL param and set persona type.
         */
        if (persona) {
          let personatype = ''
          const list = drop.parentElement.querySelectorAll('.dropdownMenu li')
          const vowels = ['a', 'e', 'i', 'o', 'u']
          let start = 'an '

          /**
           * Check for toggle val and match it with the corresponding list item persona
           */
          if (document.location.href.indexOf('#toggle-1') > -1) {
            if (list.length > 0) {
              const p = list[0].dataset.persona
              personatype = 'persona--' + p.toLowerCase()
              if (!vowels.includes(p[0].toLowerCase())) {
                start = 'a '
              }
              drop.querySelector('span').innerHTML = start + p.charAt(0).toUpperCase() + p.slice(1)
            }
          }

          if (document.location.href.indexOf('#toggle-2') > -1) {
            if (list.length > 1) {
              const p = list[1].dataset.persona
              personatype = 'persona--' + p.toLowerCase()
              if (!vowels.includes(p[0].toLowerCase())) {
                start = 'a '
              }
              drop.querySelector('span').innerHTML = start + p.charAt(0).toUpperCase() + p.slice(1)
            }
          }

          if (document.location.href.indexOf('#toggle-3') > -1) {
            if (list.length > 2) {
              const p = list[2].dataset.persona
              personatype = 'persona--' + p.toLowerCase()
              if (!vowels.includes(p[0].toLowerCase())) {
                start = 'a '
              }
              drop.querySelector('span').innerHTML = start + p.charAt(0).toUpperCase() + p.slice(1)
            }
          }

          let p = document.querySelector('.persona')
          /**
           * Check if element exists
           */
          if (p !== null) {
            if (personatype !== '') {
              p.classList.remove('persona--onLoad', 'persona--undergraduate', 'persona--postgraduate', 'persona--domestic', 'persona--international')
              p.classList.add(personatype)
            }
          }
        }

        /**
         * Give element an ID to use later
         */
        drop.setAttribute('id', 'dropdown__selected_' + index)

        /**
         * Call function on click
         */
        drop.addEventListener('click', e =>
          toggleListVisibility(e)
        )

        document.querySelector('body').addEventListener('keydown', e =>
          toggleListVisibility(e)
        )

        /**
         * Call function on key press
         */
        drop.addEventListener('keydown', e =>
          toggleListVisibility(e)
        )

        /**
         * Add each list item's id to the listItems array and add ids and tabindex to li's
         */
        listItems.forEach((item, i) => {
          let id = 'option_' + index + '_' + i
          listItemIds.push(id)
          // item.setAttribute('tabindex', 0)
          item.setAttribute('id', id)
        })

        /**
         * Add events to all list items
         */
        listItems.forEach(item => {
          item.addEventListener('click', e => {
            closeList()
          })

          item.querySelector('a').addEventListener('click', e => {
            e.preventDefault()

            doSelect()
          })

          item.addEventListener('keydown', e => {
            switch (e.keyCode) {
              case ENTER_KEY_CODE:
                doSelect()
                break
              case ESCAPE_KEY_CODE:
                closeList()
                break
              default:
                break
            }
          })

          /**
           * @description Checks if is a persona drop or not and either redirects to link val or updates class
           *
           * @example //
           */
          function doSelect () {
            closeList()

            if (persona) {
              drop.querySelector('span').innerHTML = item.querySelector('a').innerHTML.split(' student')[0]
              let p = document.querySelector('.persona')
              /**
               * Check if element exists
               */
              if (p !== null) {
                /**
                 * Multiple removes as IE11 can't handle more than 1
                 */
                p.classList.remove('persona--onLoad')
                p.classList.remove('persona--undergraduate')
                p.classList.remove('persona--postgraduate')
                p.classList.remove('persona--domestic')
                p.classList.remove('persona--international')
                p.classList.add('persona--' + item.dataset.persona.toLowerCase())
              }
            } else {
              drop.querySelector('span').innerHTML = item.querySelector('a').innerHTML
              document.location.href = item.querySelector('a').href
            }
          }
        })

        /**
         * @description Closes the list container and sets aria
         *
         * @example //
         */
        function closeList () {
          list.classList.remove('dropdownMenu--open')
          list.setAttribute('aria-expanded', false)

          const svg = drop.querySelector('svg')
          if (typeof svg !== 'undefined' && svg !== null) {
            svg.remove()
            let i = document.createElement('i')
            i.className = 'fas fa-caret-down'
            drop.appendChild(i)
          }
        }

        /**
         * @description Toggles the visibility
         *
         * @param {Object} e - Key press event.
         * @example //
         */
        function toggleListVisibility (e) {
          if (e.keyCode === ESCAPE_KEY_CODE) {
            closeList()
          }

          if (e.type === 'click') {
            list.classList.toggle('dropdownMenu--open')
            list.setAttribute(
              'aria-expanded',
              list.classList.contains('dropdownMenu--open')
            )

            /**
             * Change Font Awesome icon open/close
             */
            if (list.classList.contains('dropdownMenu--open')) {
              drop.querySelector('svg').remove()
              let i = document.createElement('i')
              i.className = 'fas fa-caret-up'
              drop.appendChild(i)
            } else {
              drop.querySelector('svg').remove()
              let i = document.createElement('i')
              i.className = 'fas fa-caret-down'
              drop.appendChild(i)
            }
          }
        }
      })
    }
  }
}

module.exports = DropdownModule
